"use client";

import * as React from "react";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";

import { cn } from "@/lib/utils";

const DropdownMenuRadioItem = React.forwardRef<
  React.ElementRef<typeof DropdownMenuPrimitive.RadioItem>,
  React.ComponentPropsWithoutRef<typeof DropdownMenuPrimitive.RadioItem>
>(({ className, children, onSelect, ...props }, ref) => (
  <DropdownMenuPrimitive.RadioItem
    ref={ref}
    className={cn(
      "flex cursor-pointer select-none items-center gap-2.5 bg-transparent px-2 py-2 text-sm outline-none hover:bg-transparent focus:bg-transparent focus:outline-none active:bg-transparent data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      className
    )}
    onSelect={(e) => {
      // Prevent the dropdown from closing on selection — callers manage apply/close.
      e.preventDefault();
      onSelect?.(e);
    }}
    {...props}
  >
    <span className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full border border-foreground">
      <DropdownMenuPrimitive.ItemIndicator>
        <div className="h-2.5 w-2.5 rounded-full bg-foreground" />
      </DropdownMenuPrimitive.ItemIndicator>
    </span>
    {children}
  </DropdownMenuPrimitive.RadioItem>
));
DropdownMenuRadioItem.displayName = DropdownMenuPrimitive.RadioItem.displayName;

export default DropdownMenuRadioItem;
